import moment from "moment";

export function getConfiguredReportsParams(
  params,
  isExternalUser,
  externalCustomerId
) {
  var paramsObj = {
    IsPlatformSpecific: false,
  };
  if (params.SearchText && params.SearchText.toString().trim().length) {
    paramsObj["SearchText"] = params.SearchText;
  }
  if (isExternalUser) {
    if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    } else {
      paramsObj["CustomerId"] = externalCustomerId;
    }
  } else {
    if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    }
  }
  if (
    params.ProjectId &&
    !(
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    )
  ) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  if (
    params.CustomerLegacyId &&
    params.CustomerLegacyId.toString().trim().length
  ) {
    paramsObj["IsPlatformSpecific"] = true;
  }
  if (params.StatusFilter && params.StatusFilter !== "All") {
    paramsObj["State"] = params.StatusFilter;
  }
  if (params.SlaFilter) {
    paramsObj["SlaFilter"] = params.SlaFilter;
  }
  if (params.Run) {
    paramsObj["Run"] = params.Run;
  }
  if (params.ChannelName) {
    paramsObj["ChannelName"] = params.ChannelName;
  }
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.PipelineDefinitionId) {
    paramsObj["PipelineDefinitionId"] = params.PipelineDefinitionId;
  }
  paramsObj["IncludeInactive"] = !!params.IncludeInactive;
  paramsObj["PageNumber"] = params.PageNumber;
  paramsObj["Size"] = params.Size;
  return paramsObj;
}

export function getFilesParams(
  params,
  isExternalUser,
  externalCustomerId,
  initParamObj
) {
  var paramsObj = initParamObj || {
    IsPlatformSpecific: false,
  };
  if (params.FileNames && params.FileNames.toString().trim().length) {
    let _fileNrs = params.FileNames.toString().trim().split(","),
      _nrs = [];
    _fileNrs.forEach((nr) => {
      if (nr.trim().length) {
        _nrs.push(nr.trim());
      }
    });
    if (_nrs.length) {
      paramsObj["FileNames"] = _nrs;
    }
  }
  if (isExternalUser) {
    if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    } else {
      paramsObj["CustomerId"] = externalCustomerId;
    }
  } else {
    if (
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    ) {
      paramsObj["CustomerId"] = params.CustomerLegacyId.toString().trim();
    } else if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    }
  }

  if (
    params.ProjectId &&
    !(
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    )
  ) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  if (
    params.CustomerLegacyId &&
    params.CustomerLegacyId.toString().trim().length
  ) {
    paramsObj["IsPlatformSpecific"] = true;
  }
  if (params.StatusFilter && params.StatusFilter !== "All") {
    paramsObj["StatusFilter"] = params.StatusFilter;
  }
  if (!isExternalUser && params.Platform && params.Platform !== "All") {
    paramsObj["Platform"] = params.Platform;

    if (params.flowid) {
      paramsObj["flowid"] = params.flowid;
    }
  }
  if (params.SlaFilter) {
    paramsObj["SlaFilter"] = params.SlaFilter;
  }
  if (params.Run) {
    paramsObj["Run"] = params.Run;
  }
  if (params.ErrorFilter) {
    paramsObj["ErrorFilter"] = params.ErrorFilter;
  }
  if (params.ExpFilter) {
    paramsObj["ExpFilter"] = params.ExpFilter;
  }
  if (params.hasbbs) {
    paramsObj["hasbbs"] = params.hasbbs;
  }
  if (params.ChannelName) {
    paramsObj["ChannelName"] = params.ChannelName;
  }
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }

  paramsObj["PageNumber"] = params.PageNumber;
  paramsObj["Size"] = params.Size;

  return paramsObj;
}

export function getDocumentsParams(
  params,
  isExternalUser,
  externalCustomerId,
  isSender
) {
  var paramsObj = {
    IsPlatformSpecific: false,
  };
  if (
    params.DocumentNumbers &&
    params.DocumentNumbers.toString().trim().length
  ) {
    let _docNrs = params.DocumentNumbers.toString().trim().split(","),
      _nrs = [];
    _docNrs.forEach((nr) => {
      if (nr.trim().length) {
        _nrs.push(nr.trim());
      }
    });
    if (_nrs.length) {
      paramsObj["DocumentNumbers"] = _nrs;
    }
  }
  if (isExternalUser) {
    if (!isSender) {
      if (params.CustomerId) {
        paramsObj["CustomerId"] = params.CustomerId;
      } else {
        paramsObj["CustomerId"] = externalCustomerId;
      }
    }
  } else {
    if (
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    ) {
      paramsObj["CustomerId"] = params.CustomerLegacyId.toString().trim();
    } else if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    }
  }
  if (
    params.ProjectId &&
    !(
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    )
  ) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  if (
    params.CustomerLegacyId &&
    params.CustomerLegacyId.toString().trim().length
  ) {
    paramsObj["IsPlatformSpecific"] = true;
  }
  if (params.DocStatus) {
    paramsObj["DocStatus"] = params.DocStatus;
  }
  if (!isExternalUser && params.Platform && params.Platform !== "All") {
    paramsObj["Platform"] = params.Platform;
  }
  if (params.DocId && params.DocId.toString().trim().length) {
    let _docIds = params.DocId.toString().trim().split(","),
      _ids = [];
    _docIds.forEach((id) => {
      if (id.trim().length) {
        _ids.push(id.trim());
      }
    });
    if (_ids.length) {
      paramsObj["DocIds"] = _ids;
    }
  }
  if (params.batch && params.batch.toString().trim().length) {
    paramsObj["batch"] = params.batch.toString().trim();
  }
  if (params.BySenderId) {
    if (params.Sender && params.Sender.toString().trim()) {
      paramsObj["SenderName"] = params.Sender.toString().trim();
    }
  } else {
    if (params.Sender && params.Sender.toString().trim()) {
      paramsObj["Sender"] = params.Sender.toString().trim();
    }
  }
  if (params.ByReceiverId) {
    if (params.Receiver && params.Receiver.toString().trim()) {
      paramsObj["ReceiverName"] = params.Receiver.toString().trim();
    }
  } else {
    if (params.Receiver && params.Receiver.toString().trim()) {
      paramsObj["Receiver"] = params.Receiver.toString().trim();
    }
  }
  if (params.Tags && params.Tags.length) {
    const tags = [];
    params.Tags.forEach((item) => tags.push(item.value));
    paramsObj["Tags"] = tags;
    paramsObj["TctIn"] = params.TctIn;
  }
  if (params.NTags && params.NTags.length) {
    const nTags = [];
    params.NTags.forEach((item) => nTags.push(item.value));
    paramsObj["NTags"] = nTags;
    paramsObj["TctIn"] = params.TctIn;
  }
  if (params.hasbbs) {
    paramsObj["hasbbs"] = params.hasbbs;
  }
  if (params.Run) {
    paramsObj["Run"] = params.Run;
  }
  if (params.ChannelName) {
    paramsObj["ChannelName"] = params.ChannelName;
  }
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  paramsObj["PageNumber"] = params.PageNumber;
  paramsObj["Size"] = params.Size;

  return paramsObj;
}

export function getDocumentsWithoutPlatformSpecificParams(
  params,
  isExternalUser,
  externalCustomerId,
  isSender
) {
  var paramsObj = {};

  if (
    params.DocumentNumbers &&
    params.DocumentNumbers.toString().trim().length
  ) {
    let _docNrs = params.DocumentNumbers.toString().trim().split(","),
      _nrs = [];
    _docNrs.forEach((nr) => {
      if (nr.trim().length) {
        _nrs.push(nr.trim());
      }
    });
    if (_nrs.length) {
      paramsObj["DocumentNumbers"] = _nrs;
    }
  }
  if (isExternalUser) {
    if (!isSender) {
      paramsObj["CustomerId"] = externalCustomerId;
    }
  } else {
    if (
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    ) {
      paramsObj["CustomerId"] = params.CustomerLegacyId.toString().trim();
    } else if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    }
  }
  if (
    params.ProjectId &&
    !(
      params.CustomerLegacyId &&
      params.CustomerLegacyId.toString().trim().length
    )
  ) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  if (
    params.CustomerLegacyId &&
    params.CustomerLegacyId.toString().trim().length
  ) {
    paramsObj["IsPlatformSpecific"] = true;
  }
  if (params.DocStatus) {
    paramsObj["DocStatus"] = params.DocStatus;
  }
  if (params.DocId && params.DocId.toString().trim().length) {
    let _docIds = params.DocId.toString().trim().split(","),
      _ids = [];
    _docIds.forEach((id) => {
      if (id.trim().length) {
        _ids.push(id.trim());
      }
    });
    if (_ids.length) {
      paramsObj["DocIds"] = _ids;
    }
  }
  if (params.batch && params.batch.toString().trim().length) {
    paramsObj["batch"] = params.batch.toString().trim();
  }
  if (params.Sender && params.Sender.toString().trim()) {
    paramsObj["Sender"] = params.Sender.toString().trim();
  }
  if (params.ByReceiverId) {
    if (params.Receiver && params.Receiver.toString().trim()) {
      paramsObj["ReceiverName"] = params.Receiver.toString().trim();
    }
  } else {
    if (params.Receiver && params.Receiver.toString().trim()) {
      paramsObj["Receiver"] = params.Receiver.toString().trim();
    }
  }
  if (params.hasbbs) {
    paramsObj["hasbbs"] = params.hasbbs;
  }
  if (params.Run) {
    paramsObj["Run"] = params.Run;
  }
  if (params.ChannelName) {
    paramsObj["ChannelName"] = params.ChannelName;
  }
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }

  paramsObj["PageNumber"] = params.PageNumber;
  paramsObj["Size"] = params.Size;

  return paramsObj;
}

export const getMomentLocaleByLang = (lang) => {
  const _langMap = {
    "en-GB": "en-gb",
    fi: "fi",
    no: "nb",
    sv: "se",
  };
  return _langMap[lang] || lang;
};

export const formatSizeUnits = (bytes) => {
  if (bytes >= 1000000000) {
    bytes = (bytes / 1000000000).toFixed(2) + " GB";
  } else if (bytes >= 1000000) {
    bytes = (bytes / 1000000).toFixed(2) + " MB";
  } else if (bytes >= 1000) {
    bytes = (bytes / 1000).toFixed(2) + " KB";
  } else if (bytes > 1) {
    bytes = bytes + " bytes";
  } else if (bytes === 1) {
    bytes = bytes + " byte";
  } else {
    bytes = "0 byte";
  }
  return bytes;
};

export const random = (len) => {
  len = len || 10;
  if (len < 5) len = 5;
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < len; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

export function timeAgo(time) {
  switch (typeof time) {
    case "number":
      break;
    case "string":
      time = new Date(time).getTime();
      break;
    case "object":
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = new Date().getTime();
  }
  var time_formats = [
    [60, "seconds", 1],
    [120, "1 minute ago", "1 minute from now"],
    [3600, "minutes", 60],
    [7200, "1 hour ago", "1 hour from now"],
    [86400, "hours", 3600],
    [172800, "Yesterday", "Tomorrow"],
    [604800, "days", 86400],
    [1209600, "Last week", "Next week"],
    [2419200, "weeks", 604800],
    [4838400, "Last month", "Next month"],
    [29030400, "months", 2419200],
    [58060800, "Last year", "Next year"],
    [2903040000, "years", 29030400],
    [5806080000, "Last century", "Next century"],
    [58060800000, "centuries", 2903040000],
  ];
  var seconds = (new Date().getTime() - time) / 1000,
    token = "ago",
    list_choice = 1;

  if (seconds === 0) return "Just now";
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = "from now";
    list_choice = 2;
  }
  var i = 0,
    format;
  while ((format = time_formats[i++]))
    if (seconds < format[0]) {
      if (typeof format[2] === "string") return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
    }
  return time;
}

export function timeStampToISODateString(d) {
  function pad(n) {
    if (n < 10) return "0" + n;
    else return n;
  }
  return (
    d.getUTCFullYear() +
    "-" +
    pad(d.getUTCMonth() + 1) +
    "-" +
    pad(d.getUTCDate()) +
    "T" +
    pad(d.getUTCHours()) +
    ":" +
    pad(d.getUTCMinutes()) +
    ":" +
    pad(d.getUTCSeconds()) +
    "Z"
  );
}

export function truncStr(str, n) {
  return str.length > n ? str.substr(0, n - 1) + "&hellip;" : str;
}

export function strip(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function handleResponse(response) {
  if (response.data.Errors && response.data.Errors.length > 0) {
    return Promise.reject(response.data.Errors[0]);
  }
  if (
    response.data.ValidationErrors &&
    response.data.ValidationErrors.length > 0
  ) {
    return Promise.reject(response.data.ValidationErrors[0]);
  }
  return Promise.resolve(response.data.Data);
}
